import { Box, ListSubheader, Menu, MenuProps, MenuItem as MUIMenuItem, SxProps } from "@mui/material";
import { useStore } from "@priolo/jon";
import { FunctionComponent, useMemo } from "react";
import { useHistory } from "react-router";
import farmSo from "stores/farm";
import growUnitSo from "stores/growUnit";
import { getFiltered } from "stores/growUnit/utils/components";
import { MenuItem } from "stores/mainMenu/types";
import { getPageIdFromComponentType, getUrlByPageId, getUrlFromComponent, getUrlFromFarmId } from "stores/route/utils/pagesId";
import { PAGE_ID } from "stores/route/utils/types";
import theme from "styles/theme";
import { groupBy } from "utils/array";



interface Props extends MenuProps {
	item: MenuItem,
}

const ParentMenu: FunctionComponent<Props> = ({
	item,
	...props
}) => {

	// STORE
	const farmSa = useStore(farmSo)
	const growUnitSa = useStore(growUnitSo)

	// HOOKs
	const history = useHistory()

	// ricava i dati da visualizzare
	const menuGroups = useMemo<GroupItems[]>(() => {
		let groups: GroupItems[] = []

		// se si tratta di una FARM
		if (item.id == PAGE_ID.FARMS) {
			farmSo.fetchAllIfVoid()
			const items = farmSa.all?.map<Item>(farm => ({
				label: farm.name ?? "--",
				isSelect: farm.id == farmSa.select?.id,
				onClick: () => {
					const url = getUrlFromFarmId(farm.id)
					if (url) history.push(url)
				}
			})) ?? []
			items.sort((i1, i2) => i1.label.localeCompare(i2.label))
			groups.push({ label: "FARMS", items })
		}

		// se si tratta di una GROWUNITS
		if (item.id == PAGE_ID.FARM_GROWUNITS) {

			// utility per ricavare il template di un gruppo
			const getTmpName = (name: string) => {
				const tmp = farmSo.state.select.edgeServicesConfig.layout?.templates?.find(t => t.name == name)
				return tmp?.title ?? tmp?.name
			}

			// normalizza il parametro "group" dei COMPONENTs (cioe' è sempre un array)
			const norm = (group: string[] | string) => group == null ? [] : Array.isArray(group) ? group : [group]

			const components = getFiltered(farmSo.state.select?.edgeServicesConfig?.components)
			const cmpGroups = groupBy(components, c => norm(c.group).join?.(" - "))
			groups = Object.entries(cmpGroups).map<GroupItems>(([label, components]) => {
				const group = norm(components[0]?.group)
				return {
					label: getTmpName(group[0]),
					sublabel: getTmpName(group[1]),
					items: components?.map<Item>(component => ({
						label: component.name ?? component.code,
						isSelect: farmSo.state.componentSelect?.code == component.code,
						onClick: () => {
							const url = getUrlFromComponent(component)
							if (url) history.push(url)
						}
					})) ?? []
				}
			})
		}

		return groups
	}, [farmSa, growUnitSa, item.id])

	// HANDLERS

	const handleClickItemMenu = (item: Item) => {
		item.onClick()
		props.onClose(null, "backdropClick");
	}

	// RENDER
	if (!(menuGroups?.length > 0)) return null

	const cmpItems = menuGroups.flatMap((group, i) => [

		!!group.label && <ListSubheader key={i} sx={sxHeader}>
			<Box sx={{ color: theme.palette.secondary.main }}>
				{group.label}
			</Box>
			{!!group.sublabel &&
				<Box sx={{ fontSize: "10px", fontWeight: 500, opacity: .9, mt: "-2px" }}>
					{group.sublabel}
				</Box>
			}
		</ListSubheader>,

		group.items.map((item, ii) =>
			<MUIMenuItem sx={{ fontSize: "14px" }} key={`${i}-${ii}`}
				onClick={() => handleClickItemMenu(item)}
				selected={item.isSelect}
			>{item.label}</MUIMenuItem>
		)

	]).filter(Boolean)


	return <Menu {...props}>
		{cmpItems}
	</Menu>

}

export default ParentMenu

const sxHeader: SxProps = {
	display: "flex", 
	flexDirection: "column", 
	py: "5px", 
	borderTop: '1px solid #ffffff4a', 
	lineHeight: "unset",
}

type GroupItems = {
	label?: string,
	sublabel?: string,
	items: Item[]
}

type Item = {
	label?: string,
	isSelect?: boolean,
	onClick?: () => void,
}